import { DataGrid } from "@mui/x-data-grid";
import { Box, Card, IconButton, Skeleton, Switch } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Link } from "react-router-dom";

export default function RedirectListing({
  isLoading,
  error,
  data,
  rowCountState,
  paginationModel,
  setPaginationModel,
  onSelectDelete,
  onToggleActive,
}) {
  const columns = [
    {
      flex: 1,
      field: "fromPath",
      headerName: "From path",
      minWidth: 220,
    },
    {
      flex: 1,
      field: "toPath",
      headerName: "To path",
      minWidth: 220,
    },
    {
      field: "statusCode",
      headerName: "Type",
      width: 90,
    },
    {
      field: "isActive",
      headerName: "Active",
      width: 100,
      sortable: false,
      headerAlign: "center",
      align: "center",
      disableClickEventBubbling: true,
      renderCell: (cell) => (
        <Switch
          size="small"
          checked={Boolean(cell.row.isActive)}
          onClick={(event) => event.stopPropagation()}
          onChange={(event) => {
            event.stopPropagation();
            onToggleActive?.(cell.row, event.target.checked);
          }}
        />
      ),
    },
    {
      flex: 1,
      field: "note",
      headerName: "Note",
      minWidth: 160,
      valueGetter: (params) => params.row.note || "",
    },
    {
      field: "edit",
      headerName: "Edit",
      sortable: false,
      width: 70,
      headerAlign: "center",
      align: "center",
      disableClickEventBubbling: true,
      renderCell: (cell) => (
        <IconButton
          variant="outlined"
          component={Link}
          to={`/redirects/edit/${cell.id}`}
        >
          <EditIcon />
        </IconButton>
      ),
    },
    {
      field: "delete",
      headerName: "Delete",
      sortable: false,
      width: 90,
      headerAlign: "center",
      align: "center",
      disableClickEventBubbling: true,
      renderCell: () => (
        <IconButton variant="contained">
          <DeleteIcon />
        </IconButton>
      ),
    },
  ];

  function handleCellClick(params) {
    if (params.field === "delete") {
      onSelectDelete(params.row);
    }
  }

  if (isLoading) {
    return (
      <Skeleton
        sx={{
          transform: "scale(1, 1.0)",
          transformOrigin: "0% 0%",
        }}
        width="100%"
        height="600px"
      />
    );
  }

  if (error) {
    return <p>Something went wrong</p>;
  }

  return (
    <Card sx={{ p: 2 }}>
      <Box sx={{ height: 600, width: "100%" }}>
        <DataGrid
          rows={data?.redirects || []}
          columns={columns}
          rowCount={rowCountState}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          loading={isLoading}
          paginationMode="server"
          onCellClick={handleCellClick}
          getRowId={(row) => row.id}
        />
      </Box>
    </Card>
  );
}
